'use strict';

import moment from 'moment';

const TreatmentFormCtrl = function ($rootScope, $state, $stateParams, $q, PatientsService, Notification, CRUDService, config, $timeout, $compile, $scope) {
  var ctrl = this,
    crossCheckMedicationDiabetesInfoPupulated = 0,
    actionId = $stateParams.actionId,
    treatId = $stateParams.treatId;

  ctrl.pid = $stateParams.pid;
  ctrl.schema = $stateParams.schema || {};
  ctrl.patient = $stateParams.patient;
  ctrl.treatment = $stateParams.treatment;
  ctrl.action = $stateParams.action;
  ctrl.change = $stateParams.change;

  ctrl.regions = ["Aorta", "Iliakal", "femoral", "popliteal", "below-the-knee", "obere Extremität"];

  // model for custom data on the main form view
  ctrl.formmodel = {};

  // global form options for angular-schema-form
  ctrl.formOptions = {
    validationMessage: {
      '0': 'Fehlerhaftes Feld.',
      '101': 'Der angegebene Wert ist niedriger als {{schema.minimum}}.',
      '103': 'Der angegebene Wert ist größer als {{schema.maximum}}.',
      '105': 'Der angegebene Wert ist keine Zahl.',
      '302': 'Nicht ausgefülltes Pflichtfeld.',
      '400': 'Die Anzahl der gewählten Einträge unterschreitet die Mindestanzahl {{schema.minItems}}.',
      '401': 'Die Anzahl der gewählten Einträge überschreitet die Maximalanzahl {{schema.maxItems}}.',
      'number': 'Der angegebene Wert ist keine Zahl.',
      'default': 'Das Feld ist nicht korrekt ausgefüllt.',
      'entlassungsError': 'Das angegebene Entlassungsdatum liegt vor dem Aufnahmedatum.',
      'diabetesMedicationError': 'Im Risikoprofil wurde unter <b>Diabetes mellitus</b> der Wert <b>Nein</b> hinterlegt.',
      'claudicatioXorRuheschmerzenError': 'Es dürfen nicht gleichzeitig Claudication <b>und</b> Ruheschmerzen ausgewählt werden.'
    },
    validateOnRender: true // initially validate form
  };

  ctrl.$onInit = function () {
    ctrl.formRequest = $q.defer();
    ctrl.formLoaded = false;
    if (!ctrl.treatment || !ctrl.action) {
      // no objects passed - retrieve them from server
      PatientsService.findByPid($stateParams.pid).then(function (data) {
        ctrl.patient = data;
        var treatments = ctrl.patient.treatments;
        // get selected treatment
        for (var i in treatments) {
          if (treatments[i].uuid === treatId) {
            ctrl.treatment = treatments[i];

            // get selected treatment action
            for (var j in treatments[i].actions) {
              if (treatments[i].actions[j].uuid === actionId) {
                ctrl.action = treatments[i].actions[j];
                if (ctrl.action.data) {
                  ctrl.data = JSON.parse(ctrl.action.data);
                  ctrl.initialData = JSON.parse(ctrl.action.data);
                } else {
                  ctrl.data = {};
                }

                break;
              }
            }
            break;
          }
        }
        PatientsService.getTreatmentForm(treatId, actionId).then(function (response) {
          ctrl.schema = response.data;
        });
      });
    }

    if ($stateParams.data) {
      ctrl.data = JSON.parse($stateParams.data);
    } else {
      ctrl.data = {};
    }

  };

  ctrl.$doCheck = function () {
    // add error icons if there are any errors in the fieldset
    jQuery('#formview .has-error').parents('fieldset').map(function () {
      if (jQuery(this).find('.fa-warning').length === 0) {
        jQuery(this).find('legend').append(' <i class="fa fa-warning" style="color: #a94442;"></i>');
      }
    });

    jQuery('#formview .fa-warning').parents('fieldset').map(function () {
      if (jQuery(this).find('.has-error').length === 0) {
        jQuery(this).find(".fa-warning").remove();
      }
    });
  };

  $rootScope.$on('sf-render-finished', function () {
    $timeout(function () {

      // initially validate form
      $rootScope.$broadcast('schemaFormValidate');

      ctrl.formRequest.resolve();

      ctrl.formLoaded = true;
    }, 0);
  });

  ctrl.formChanged = function () {
    if (ctrl.action) {
      if (ctrl.action.lastModifiedAt === ctrl.action.createdAt) {
        return false;
      } else {
        return !angular.equals(ctrl.data, ctrl.initialData);
      }
    }
  };

  ctrl.validateForm = function (form) {
    $rootScope.$broadcast('schemaFormValidate');

    if (form.$valid) {
      Notification.success("Das Formular enthält keine Fehler.");
    } else {
      Notification.warning("Das Formular enthält Fehler. Die betroffenen Felder wurden entsprechend markiert.");
    }
  };

  function saveForm(form, customform) {
    if (customform.$valid) {

      $rootScope.$broadcast('schemaFormValidate');
      ctrl.formmodel.valid = form.$valid;
      ctrl.action.valid = form.$valid;

      PatientsService.saveTreatmentForm(ctrl.treatment, ctrl.action, ctrl.data, ctrl.formmodel).then(
        function () {
          Notification.success("Datenaufnahme wurde erfolgreich gespeichert.");
          $state.go('main.patients.list.details.treatsteps', {
            treatId: ctrl.treatment.uuid,
            treatment: ctrl.treatment,
            patient: ctrl.patient,
            pid: ctrl.patient.pid
          });
        }, function () {
          Notification.error("Datenaufnahme konnte nicht gespeichert werden.");
          $state.go('main.patients.list.details.treatsteps', {
            treatId: ctrl.treatment.uuid,
            treatment: ctrl.treatment,
            patient: ctrl.patient,
            pid: ctrl.patient.pid
          });
        });
    }
  }

  ctrl.submitForm = function (form, customform) {
    if (angular.equals(ctrl.data, ctrl.initialData)) {
      // form hasn't been touched - save it without password request
      // saving the form althought there are no changes is intended here to trigger some data update, e.g. target lesion detection
      saveForm(form, customform);
    } else if (ctrl.action.lastModifiedAt !== ctrl.action.createdAt) {
      // this is not the first edit of the form, so check the password here

      CRUDService.save({ "password": ctrl.formmodel.confirmPw + "" }, config.urls.users + '/checkPw').then(function () {
        // success response here means that the password was correct

        saveForm(form, customform);
      }, function () {
        // password was incorrect
        Notification.error('Falsches Passwort - Formular wurde nicht gespeichert.');
        ctrl.formmodel.confirmPw = "";
      });
    } else {
      // this is the first edit, so just save the form here
      saveForm(form, customform);
    }
  };

  ctrl.resetForm = function () {
    if (ctrl.action.createdAt === ctrl.action.lastModifiedAt) {
      PatientsService.removeTreatmentAction(ctrl.treatment.uuid, ctrl.action.uuid).then(() => {
        ctrl.treatment.actions = ctrl.treatment.actions.filter(e => e.uuid !== ctrl.action.uuid);
      });
    }
    $state.go('main.patients.list.details.treatsteps', {
      treatId: ctrl.treatment.uuid,
      treatment: ctrl.treatment,
      patient: ctrl.patient,
      pid: ctrl.pid
    });
  };

  // watch specific fields to reset dependent fields
  $scope.$watch(function () {
    if (ctrl.data['zentrum']) {
      return ctrl.data['zentrum']['datum_aufnahme'] + ctrl.data['zentrum']['datum_entlassung'];
    }
  }, function (newVal, oldVal) {
    if (ctrl.data['zentrum'] && ctrl.data['zentrum']['datum_aufnahme'] && ctrl.data['zentrum']['datum_entlassung']) {
      ctrl.data['zentrum']['verweildauer'] = ctrl.calculateDateRange(ctrl.data['zentrum']['datum_aufnahme'],
        ctrl.data['zentrum']['datum_entlassung']);

      // check that datum_entlassung is after datum_aufnahme
      if (!moment(ctrl.data['zentrum']['datum_entlassung'], "DD.MM.YYYY").isSameOrAfter(moment(ctrl.data['zentrum']['datum_aufnahme'], "DD.MM.YYYY"))) {
        $scope.$broadcast('schemaForm.error.zentrum.datum_entlassung', 'entlassungsError', false);
        ctrl.data['zentrum']['verweildauer'] = null;
      } else {
        $scope.$broadcast('schemaForm.error.zentrum.datum_entlassung', 'entlassungsError', true);
      }
    }
  });

  $scope.$watch(function () {
    if (ctrl.data['symptomatik']) {
      return ctrl.data['symptomatik']['symptome_linkes_bein'] + ctrl.data['symptomatik']['symptome_rechtes_bein'];
    }
  }, function (newVal, oldVal) {
    if (ctrl.data['symptomatik'] && ctrl.data['symptomatik']['symptome_linkes_bein']) {
      console.log(ctrl.data['symptomatik']['symptome_linkes_bein']);
      if(ctrl.data['symptomatik']['symptome_linkes_bein'].indexOf('Claudicatio') > -1 && ctrl.data['symptomatik']['symptome_linkes_bein'].indexOf('Ruheschmerzen') > -1){
        $scope.$broadcast('schemaForm.error.symptomatik.symptome_linkes_bein', 'claudicatioXorRuheschmerzenError', false);
      }else{
        $scope.$broadcast('schemaForm.error.symptomatik.symptome_linkes_bein', 'claudicatioXorRuheschmerzenError', true);
      }
    }
    if (ctrl.data['symptomatik'] && ctrl.data['symptomatik']['symptome_rechtes_bein']) {
      if(ctrl.data['symptomatik']['symptome_rechtes_bein'].indexOf('Claudicatio') > -1 && ctrl.data['symptomatik']['symptome_rechtes_bein'].indexOf('Ruheschmerzen') > -1){
        $scope.$broadcast('schemaForm.error.symptomatik.symptome_rechtes_bein', 'claudicatioXorRuheschmerzenError', false);
      }else{
        $scope.$broadcast('schemaForm.error.symptomatik.symptome_rechtes_bein', 'claudicatioXorRuheschmerzenError', true);
      }
    }
  });

  /**
   * print error message if no diabetes mellitus but antidiabetica medication
   * - use crossCheckMedicationDiabetesInfoPupulated to call broatcast only if necessary
   * - always return true, otherwise field is not visible
   * @param {*} diabetes 
   * @param {*} antidiabetica 
   */
  ctrl.crossCheckMedicationDiabetes = function (diabetes, antidiabetica) {
    if (diabetes === undefined && antidiabetica == undefined) {
      return true;
    }
    if (diabetes === 'Nein' && antidiabetica === 'Einnahme') {
      if (crossCheckMedicationDiabetesInfoPupulated != 2) {
        $scope.$broadcast('schemaForm.error.medikation.orales_antidiabetikum', 'diabetesMedicationError', false);
        crossCheckMedicationDiabetesInfoPupulated = 2;
      }
    } else {
      if (crossCheckMedicationDiabetesInfoPupulated != 1) {
        $scope.$broadcast('schemaForm.error.medikation.orales_antidiabetikum', 'diabetesMedicationError', true);
        crossCheckMedicationDiabetesInfoPupulated = 1;
      }
    }
    return true;

  };

  ctrl.calculateRutherford = function (symptome, schwere, laesionen) {
    var rutherford = 0;
    if (symptome && symptome.indexOf('Claudicatio') > -1) {
      if (schwere === 'Gering') {
        rutherford = 1;
      }
      if (schwere === 'Mäßig') {
        rutherford = 2;
      }
      if (schwere === 'Schwer') {
        rutherford = 3;
      }
    }
    if (symptome && symptome.indexOf('Ruheschmerzen') > -1) {
      rutherford = 4;
    }
    if (laesionen === 'Zehen' || laesionen === 'Vorfuß') {
      rutherford = 5;
    }
    if (laesionen === 'Mittelfuß' || laesionen === 'Rückfuß') {
      rutherford = 6;
    }
    return rutherford;
  };

  ctrl.calculateABI = function (rrNiedrigster, rrLinks, rrRechts) {
    var abi = -1;
    rrLinks = rrLinks || 0;
    rrRechts = rrRechts || 0;

    if (Math.abs(rrLinks - rrRechts) > 10) {
      abi = rrNiedrigster / Math.max(rrLinks, rrRechts);
    } else {
      abi = rrNiedrigster / ((rrLinks + rrRechts) / 2);
    }
    abi = roundNumber(abi, 2);

    return abi;
  };


  function roundNumber(num, scale) {
    if (("" + num).indexOf("e") === -1) {
      return +(Math.round(num + "e+" + scale) + "e-" + scale);
    } else {
      var arr = ("" + num).split("e"),
        sig = "";
      if (+arr[1] + scale > 0) {
        sig = "+";
      }
      return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
    }
  }

  ctrl.calculateDateRange = function (date1, date2) {
    date1 = typeof date1.getMonth === 'function' ? date1 : moment(date1, "DD.MM.YYYY").toDate();
    date2 = typeof date2.getMonth === 'function' ? date2 : moment(date2, "DD.MM.YYYY").toDate();

    var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

    return date1.getTime() === date2.getTime() ? 1 : Math.round(Math.abs((date1.getTime() - date2.getTime()) / (oneDay)));
  };

  ctrl.syncFields = function (value, form, selector) {
    // check that given type and target type match
    if (value !== undefined &&
      Object.prototype.toString.call(value).match(/^\[object\s(.*)\]$/)[1].toLowerCase() === form.schema.type
    ) {
      ctrl.data[selector[0]][selector[1]] = value;
    }
  };

  $rootScope.$on('treatmentform:updateValue', function (event, params) {
    var key = params["key"].split('.');
    if (ctrl.data[key[0]]) {
      ctrl.data[key[0]][key[1]] = params["value"];
    }
  });
};

TreatmentFormCtrl.$inject = ['$rootScope', '$state', '$stateParams', '$q', 'PatientsService', 'Notification', 'CRUDService', 'config', '$timeout', '$compile', '$scope'];

module.exports = {
  template: require('./formview.html'),
  controller: TreatmentFormCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/form-treatment/form-treatment.component.js